import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { setFreshBooksAuthorizationUrl, setTenantList, componentKey as freshbooksComponentKey, setLoadingState, setFormAndTaxYearList, setImportData, setFormSettings, setIsImportDataGridViewLoaded } from "./FreshBooksSlice";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { INTEGRATION_WRAPPER_LOADING_STATES } from "../constants";
import FormsDataService from "../../../../../services/FormsDataService";


export const { getFreshBooksUrl, connectToFreshBooks, getLoadImportData, getFormAndTaxYearList, getFormSetting, disconnectToFreshBooks } = {
    getFreshBooksUrl: (payload) => {
        return {
            type: "FRESHBOOKS/GET_AUTHENTICATEURL",
            payload: payload
        }
    },
    connectToFreshBooks: (payload) => {
        return {
            type: "FRESHBOOKS/GET_CONNECTFRESHBOOKS",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "FRESHBOOKS/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "FRESHBOOKS/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "FRESHBOOKS/GET_FORM_SETTING",
            payload: payload
        }
    },
    disconnectToFreshBooks: (payload) => {
        return {
            type: "FRESHBOOKS/GET_DISCONNECTFRESHBOOKS",
            payload: payload
        }
    },
}

function* getFreshBooksUrlAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.freshbooksIndex();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                yield put(setFreshBooksAuthorizationUrl(response?.data?.Data));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch FreshBooks Url",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch FreshBooks Url", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* connectToFreshBooksAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.connectToFreshBooks(action.payload);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                const tenantData = response?.data?.Data || [];
                yield put(setTenantList(tenantData));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to Connect FreshBooks",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to Connect FreshBooks", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                yield put(setImportData(response?.data?.Data));
                yield put(setIsImportDataGridViewLoaded(true));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Import Data",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                const data = response?.data?.Data;
                const filteredFormType = data.FormType.filter(form => form.value === "NEC");
                const updatedData = {
                    TaxYear: data.TaxYear,
                    FormType: filteredFormType
                };
                yield put(setFormAndTaxYearList(updatedData));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch TaxYear And Form Types",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_LOADING }));
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                if (response.data.Data) {
                    yield put(setFormSettings(response?.data?.Data));
                }
                else {
                    yield put(addNotifications({
                        heading: "Error",
                        message: "An error occurred while fetching the Data",
                        variant: TOASTER_VARIANT.DANGER
                    }));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}

function* disconnectToFreshBooksAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { removedTenant } = action.payload;
        const response = yield IntegrationDataService.disconnectFreshBooks(removedTenant);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(addNotifications({
                heading: "Disconnected",
                message: "You have been successfully disconnected.",
                variant: TOASTER_VARIANT.SUCCESS
            }))
            yield put(setTenantList(null));
        }
    }
    catch {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFreshBooksUrl().type, getFreshBooksUrlAsync),
        takeLatest(connectToFreshBooks().type, connectToFreshBooksAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
        takeLatest(disconnectToFreshBooks().type, disconnectToFreshBooksAsync),
    ]);
}
store.sagaManager.addSaga(freshbooksComponentKey, rootSaga);